import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CtDashboardsService } from '@cloud-twin-v2/ct-dashboards/ct-dashboards.service';
import { cloudTwinDynamicLayoutExternalSettings } from '@cloud-twin-v2/settings/cloud-twin-dynamic-layout-external-settings';
import { CommonMainLayoutModule } from '@common-modules/main-layout/common-main-layout.module';
import { CommonNavigationModule } from '@common-modules/navigation/common-navigation.module';
import { CommonSharedModule } from '@common-modules/shared/common-shared.module';
import { CtDashboardsModule } from './../ct-dashboards/ct-dashboards.module';
import { CtMainLayoutComponent } from './ct-main-layout/ct-main-layout.component';
import { MainAccountCardComponent } from './main-account-card/main-account-card.component';
import { MainTopBarComponent } from './main-top-bar/main-top-bar.component';
import { VersionInfoPopupComponent } from './version-info-popup/version-info-popup.component';

@NgModule({
  declarations: [
    CtMainLayoutComponent,
    MainTopBarComponent,
    MainAccountCardComponent,
    VersionInfoPopupComponent,
  ],
  imports: [
    CommonModule,
    CommonSharedModule,
    CtDashboardsModule,
    CommonMainLayoutModule.forFeature({
      rightPanelSettings: {
        dashboardsService: CtDashboardsService,
        dynamicLayoutSettings: cloudTwinDynamicLayoutExternalSettings,
      },
    }),
    CommonNavigationModule,
  ],
  exports: [CtMainLayoutComponent],
})
export class CtMainLayoutModule {}
